import React from 'react'
import Svg from './Svg'
export const SvgInbox = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M23.837 11.34l-5.96-7.45a.747.747 0 00-.582-.279H6.866a.746.746 0 00-.582.279l-5.96 7.45a.742.742 0 00-.163.465v6.705c0 .823.667 1.49 1.49 1.49H22.51A1.49 1.49 0 0024 18.51v-6.705a.748.748 0 00-.163-.465zm-1.327 1.21h-5.215l-2.98 2.98h-4.47l-2.979-2.98H1.651v-.483l5.573-6.966h9.713l5.574 6.966v.483z" />
  </Svg>
))
SvgInbox.isIcon = true
export default SvgInbox
